/* image_type_rommon.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.7 20.5" preserveAspectRatio="none">
        <path class="foreground-gl" d="M19.9.28H3A2.22,2.22,0,0,0,.75,2.51V18.08A2.32,2.32,0,0,0,3.06,20.4H19.72a2.52,2.52,0,0,0,2.51-2.52V2.62A2.33,2.33,0,0,0,19.9.28Zm-12.78,14L5.26,10.52h-.7v3.77h-2V4.78H5.8A5.32,5.32,0,0,1,7,4.92a3.06,3.06,0,0,1,1.05.48,2.34,2.34,0,0,1,.75.89,3.06,3.06,0,0,1,.28,1.37A2.68,2.68,0,0,1,8.6,9.28a2.52,2.52,0,0,1-1.3.94l2.24,4.07Zm12.86,0H18l0-6.73h0l-2.23,6.73H14.28L12.12,7.56h0l.05,6.73H10.19V4.78h2.94l1.95,6.1h0L17,4.78h3Z"/>
        <path class="foreground-gl" d="M6.58,6.83a1.41,1.41,0,0,0-.45-.15,2.74,2.74,0,0,0-.48,0H4.54V8.85h1a2.35,2.35,0,0,0,.52,0,1.57,1.57,0,0,0,.49-.16,1,1,0,0,0,.35-.35A1.05,1.05,0,0,0,7,7.7a1.09,1.09,0,0,0-.12-.55A1,1,0,0,0,6.58,6.83Z"/>
        </svg>
    `
};
